import { cn } from '@ecom/helper-react-class-combine';

export interface TitleProps {
  title: string;
  id?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses: Record<NonNullable<TitleProps['size']>, string> = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-3xl',
  xl: 'text-4xl',
};

export function Title({ title, id, size = 'lg', className }: TitleProps) {
  return (
    <h1
      id={id}
      className={cn(
        'font-heading text-center',
        sizeClasses[size],
        'mt-2 max-lg:mb-3 lg:mb-5',
        className,
      )}
    >
      {title}
    </h1>
  );
}
